import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";

@Injectable({ providedIn: "root" })
export class NavigationService {
  private history: string[] = [];

  constructor(
    private router: Router,
    private location: Location,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  navigate(url: string) {
    return this.router.navigateByUrl(url);
  }

  back() {
    this.history.pop();
    if (this.history.length > 0) {
      return this.location.back();
    }
    return this.router.navigateByUrl("/");
  }
}
